import { LoadState } from "../../../constants/enums";

export interface ILifeInsurancePolcyComplianceCheckListState {
  data: ILifeInsurancePolcyComplianceCheckList;
  loading: LoadState;
  error: string | null;
}

export interface ILifeInsurancePolcyComplianceCheckList {
  customer_id: number;
  customer_policy_id: number;
  advisor_disclosure: string | null;
  kyc_insurance_needs_financial_needs_analysis: string | null;
  consent: string | null;
  privacy_statement: string | null;
  lird: string | null;
  investor_profile: string | null;
  overall_product_suitability: string | null;
  notes: string | null;
  compliance_status: string | null;
  advisor_disclosure_file: string;
  notes_file: string;
  overall_product_suitability_file: string;
  lird_file: string;
  investor_profile_file: string;
  kyc_insurance_needs_financial_needs_analysis_file: string;
  privacy_statement_file: string;
  consent_file: string;
  compliance_status_file: string;
  status: string | null;
}

export interface IComplianceFiles {
  advisor_disclosure_file: File | null;
  notes_file: File | null;
  overall_product_suitability_file: File | null;
  lird_file: File | null;
  investor_profile_file: File | null;
  kyc_insurance_needs_financial_needs_analysis_file: File | null;
  privacy_statement_file: File | null;
  consent_file: File | null;
  compliance_status_file: File | null;
};

export const defaultLifeInsurancePolicyComplianceCheckList: ILifeInsurancePolcyComplianceCheckListState =
  {
    data: {
      customer_id: 0,
      customer_policy_id: 0,
      advisor_disclosure: null,
      advisor_disclosure_file: "",
      kyc_insurance_needs_financial_needs_analysis: null,
      kyc_insurance_needs_financial_needs_analysis_file: "",
      consent: null,
      consent_file: "",
      privacy_statement: null,
      privacy_statement_file: "",
      lird: null,
      lird_file: "",
      investor_profile: null,
      investor_profile_file: "",
      overall_product_suitability: null,
      overall_product_suitability_file: "",
      notes: null,
      notes_file: "",
      compliance_status: null,
      compliance_status_file: "",
      status: "ACTIVE",
    },
    loading: LoadState.NotLoaded,
    error: null,
  };
